import styled from 'styled-components';
import { TIMELINE_COLORS } from './timelineStyles';

export const RegionRow = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom-color: hsla(0, 0%, 100%, 0.23);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  align-items: stretch;
  flex-direction: row;
  width: 100%;
`;

export const RegionControlRow = styled(RegionRow)`
  position: relative;
  z-index: 100;
  height: 20px;
  cursor: pointer;
  border-top: 1px solid #c5cdd9;
  background-color: ${TIMELINE_COLORS.controlBackground};
`;

export const DayGrid = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  padding: 0 2px;
  height: 30px;
  flex: 1;
  &:hover {
    outline: 1px solid rgb(85, 105, 125);
  }
`;

export const DayGridDay = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  position: relative;
  padding-top: 2px;
  height: 30px;
  margin: 0;
  flex: 1;
`;

export const DayGridText = styled.div<{ dimmed?: boolean }>`
  color: #000;
  text-align: left;
  margin-left: 1em;
  line-height: 10px;
  font-size: 12px;
  font-weight: 700;
  opacity: ${(props) => (props.dimmed ? 0.3 : 1)};
  flex: 1;
`;

export const Interval = styled.div`
  border-left: 1px solid hsla(0, 0%, 100%, 0.23);
  text-align: center;
  line-height: 30px;
  cursor: pointer;
  color: #000;
`;

export const RegionToggle = styled.div<{ offset?: number }>`
  align-items: center;
  position: sticky;
  display: flex;
  height: 21px;
  left: ${({ offset }) => (offset ? `calc(50% - ${offset * 3}px)` : '50%')};
  font-size: 0.6875rem;
  background-color: ${TIMELINE_COLORS.regionToggleBackground};
  color: #000000;
  padding: 4px 10px;
  border-radius: 30px;
  transform: translateY(-1px);
  & > div[dir='auto'] {
    font-size: 0.6875rem;
    max-width: 70vw;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const RegionHeader = styled.div`
  background-color: ${TIMELINE_COLORS.backgroundGray};
  justify-content: flex-start;
  align-items: flex-start;
  align-self: stretch;
  padding: 8px 14px;
  display: flex;
  height: 30px;
  flex: 1;

  font-size: 0.875rem;
  line-height: 1.2em;
  text-align: left;
  color: #000;
`;
